import gql from 'graphql-tag';

export const COMMAND_JOB_CREATE = gql`
  mutation ($input: CommandJobInput!){
    commandJobCreate(input: $input) {
      status
      action
    }
 }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/jobs/create.js